<template>
  <div class="box">
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="newGardenId" :placeholder="$t('lang.lab_chooseGarden')" class="select" v-if="gardenId === 0">
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="0"></el-option>
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="gardenId" :placeholder="$t('lang.lab_chooseGarden')" class="select" :disabled="gardenId != 0" v-if="gardenId != 0">
            <el-option key :label="$t('lang.lab_chooseGarden')" :value="gardenId"></el-option>
            <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="search()">{{commitname}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button slot="header" size="medium" type="primary" @click="addShowDialog(), isAdd = 1">{{$t('lang.lab_addMachineRoom')}}</el-button>
      <el-table :data="tableData" class="wid100" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109">
        <el-table-column type="selection" width="55" v-if="this.postAuditListcheckbox"></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod" align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="machineRoomName" :label="$t('lang.lab_machineRoomName')"></el-table-column>
        <el-table-column prop="deviceName" :label="$t('lang.lab_deviceName')"></el-table-column>
        <el-table-column prop="dutyPersonName" :label="$t('lang.lab_dutyPersonName')"></el-table-column>
        <el-table-column prop="dutyPersonPhone" :label="$t('lang.lab_dutyPersonPhone')"></el-table-column>
        <el-table-column :label="$t('lang.lab_operation')" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row.id), isAdd = 0">{{modifyname}}</el-button>
            <el-button class="orange" @click="deleteList(scope.row.id)">{{deletename}}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="sizes, prev, pager, next, jumper"
          :page-count="pageCount"
          />
    </el-card>
    <!-- 弹框的title未动态变更，全显示编辑机房设备 -->
    <el-dialog
      :visible.sync="show"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      :title="changeTitle"
      @closed="handleDialogClosed"
    >
      <el-scrollbar>
        <el-form ref="form" :model="form" :label-width="require('@/config/enum').c_ws7" :label-suffix="require('@/config/enum').c_colon" :rules="rules" class="form_show">
          <el-form-item :label="$t('lang.lab_garden')" prop="gardenss" v-if="this.gardenId === 0">
            <el-select v-model="form.garden" :placeholder="$t('lang.lab_chooseGarden')" class="select">
              <el-option key="0" :label="$t('lang.lab_chooseGarden')" value=""></el-option>
              <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_garden')" prop="garden" v-if="this.gardenId != 0">
            <el-select v-model="form.garden" :placeholder="$t('lang.lab_chooseGarden')" class="select" :disabled="true">
              <el-option key="0" :label="$t('lang.lab_chooseGarden')" value=""></el-option>
              <el-option v-for="item in types" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_machineRoomName')" prop="machineRoomName">
            <el-input v-model="form.machineRoomName" :placeholder="$t('lang.lab_inputMachineRoomName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_deviceName')" prop="deviceName">
            <el-input v-model="form.deviceName" :placeholder="$t('lang.lab_inputDeviceName')"></el-input>
          </el-form-item>
            <el-form-item :label="$t('lang.lab_state')" prop="state">
            <el-radio-group v-model="form.state">
              <el-radio :label="1">{{$t('lang.lab_machineRoomTS')}}</el-radio>
              <el-radio :label="0">{{$t('lang.lab_machineRoomZC')}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_dutyPersonName')" prop="dutyPersonName">
            <el-input v-model="form.dutyPersonName" :placeholder="$t('lang.lab_inputDutyPersonName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.lab_dutyPersonPhone')" prop="dutyPersonPhone">
            <el-input v-model="form.dutyPersonPhone" :placeholder="$t('lang.lab_inputDutyPersonPhone')"></el-input>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <div slot="footer">
        <el-button @click="rest('form')" class="cancel">{{$t('lang.btn_rest')}}</el-button>
        <el-button type="primary" :disabled="isDisabled"  @click="onSubmit('form')" v-if="isAdd === 0">{{$t('lang.btn_save')}}</el-button>
        <el-button type="primary" :disabled="isDisabled"  @click="addMachineroom('form')" v-if="isAdd === 1">{{$t('lang.btn_save')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:machineroom
 *@Description:机房设备管理列表  弹框添加/编辑
 *@author:刘彦辰
 *@Copyright:格众科技
 *@date:2020-03-12
 */

export default {
  data () {
    var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    var isPhone = (rule, value, callback) => {
      if (value === '') {
        callback(
          new Error(
            this.$i18n.t('lang.lab_pleInputTel')
          )
        )
      } else if (!phone.test(value)) {
        callback(
          new Error(this.$i18n.t('lang.lab_inputDutyPersonPhoneIsTrue'))
        )
      }
      callback()
    }
    var chooseGardenId = (rule, value, callback) => {
      if (this.form.garden === '') {
        callback(new Error(this.$i18n.t('lang.lab_please_Select') + this.$i18n.t('lang.diaFormgardenId')))
      } else {
        callback()
      }
    }
    return {
      gardenId: this.$store.getters.gardenId,
      saveData: '', // 存储json字符串
      show: false, // 弹框开关
      pageCount: 0,
      pageNum: 1,
      pageSize: 10,
      tableData: [],
      types: [],
      isDisabled: '',
      changeTitle: '',
      input: '',
      isAdd: 0,
      multipleSelection: [], // 多选框
      editId: '',
      newGardenId: 0,
      form: {
        garden: '',
        machineRoomName: '',
        state: '',
        deviceName: '',
        dutyPersonName: '',
        dutyPersonPhone: '',
        type: 1,
        parentId: 0
      },
      rules: {
        machineRoomName: [
          { required: true, message: this.$i18n.t('lang.lab_inputMachineRoomName'), trigger: 'blur' },
          { max: 20, message: this.$i18n.t('lang.lab_inputMachineRoomNameIs20'), trigger: 'blur' }
        ],
        gardenss: [
          { required: true, validator: chooseGardenId, trigger: 'change' }
        ],
        deviceName: [
          { required: true, message: this.$i18n.t('lang.lab_inputDeviceName'), trigger: 'blur' },
          { max: 20, message: this.$i18n.t('lang.lab_inputDeviceNameIs20'), trigger: 'blur' }
        ],
        dutyPersonName: [
          { required: true, message: this.$i18n.t('lang.lab_inputDutyPersonName'), trigger: 'blur' },
          { max: 20, message: this.$i18n.t('lang.lab_inputDutyPersonNameIs20'), trigger: 'blur' }
        ],
        dutyPersonPhone: [
          { required: true, validator: isPhone, trigger: 'blur' }
        ]
      },
      postAuditListcheckbox: require('@/config/enum').postAuditListcheckbox, // 是否隐藏复选框
      commitname: require('@/config/enum').commitname,
      deletename: require('@/config/enum').deletename,
      modifyname: require('@/config/enum').modifyname
    }
  },
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.list()
    },
    form: {
      handler(newVal, oldVal) {
       let tempRule = JSON.stringify(newVal)
        if (tempRule === this.saveData) {
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.list()
    this.gardens()
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.$refs.form.resetFields()
      this.form.garden = ''
      this.form.machineRoomName = ''
      this.form.state = ''
      this.form.deviceName = ''
      this.form.dutyPersonName = ''
      this.form.dutyPersonPhone = ''
    },
    // 点击添加按钮
    addShowDialog() {
      if (this.gardenId === 0) {
        this.form.garden = ''
      } else {
        this.form.garden = this.gardenId
      }
      this.form.machineRoomName = ''
      this.form.state = ''
      this.form.deviceName = ''
      this.form.dutyPersonName = ''
      this.form.dutyPersonPhone = ''
      this.changeTitle = this.$i18n.t('lang.lab_addMachineRoom')
      this.show = true
    },
    // 重置弹框内容
    rest(form) {
      this.$refs[ form ].resetFields()
      // if (this.gardenId === 0) {
      //   this.form.garden = ''
      // } else {
      //   this.form.garden = this.gardenId
      // }
      this.form.machineRoomName = ''
      this.form.state = ''
      this.form.deviceName = ''
      this.form.dutyPersonName = ''
      this.form.dutyPersonPhone = ''
    },
    // 列表隔行变色
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区下拉
    gardens() {
      let loading = this.$loading()
      this.$get(`/gardens`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.types = res.list
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 添加机房设备
    addMachineroom(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.form.garden === '0') {
            this.$message.error('请选择小区')
          } else {
            let params = {
              gardenId: this.form.garden,
              machineRoomName: this.form.machineRoomName,
              state: this.form.state,
              deviceName: this.form.deviceName,
              dutyPersonName: this.form.dutyPersonName,
              dutyPersonPhone: this.form.dutyPersonPhone,
            }
            let loading = this.$loading()
            this.$postJson(`/machineDevice`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    // 编辑页面保存
    onSubmit(from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (this.form.garden === '0') {
            this.$message.error('请选择小区')
          } else {
            let parames = {
              gardenId: this.form.garden,
              machineRoomName: this.form.machineRoomName,
              state: this.form.state,
              deviceName: this.form.deviceName,
              dutyPersonName: this.form.dutyPersonName,
              dutyPersonPhone: this.form.dutyPersonPhone,
              type: this.form.type,
              parentId: this.form.parentId,
            }
            let loading = this.$loading()
            this.$patch(`/machineDevice/${this.editId}`, parames).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.show = false
                  this.commit()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          }
        } else {
          return false
        }
      })
    },
    // 机房设备列表
    list() {
      let loading = this.$loading()
      if (this.gardenId === 0 && this.newGardenId != 0) {
        var url = `/machineDevice?gardenId=${this.newGardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      } else {
        url = `/machineDevice?gardenId=${this.gardenId}&pageSize=${this.pageSize}&pageNo=${this.pageNum}`
      }
      this.$get(url).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 点击换页
    handleCurrentChange(val) {
      this.pageNum = val
      this.list()
    },
    // 点击更改每页容量
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.list()
    },
    commit() {
      this.pageNum = 1
      this.list()
    },
    // 点击编辑按钮
    edit(id) {
      let loading = this.$loading()
      this.$get(`/machineDeviceById/` + id).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.editId = id
            this.form.garden = res.machineDevice.gardenId
            this.form.machineRoomName = res.machineDevice.machineRoomName
            this.form.state = res.machineDevice.state
            this.form.deviceName = res.machineDevice.deviceName
            this.form.dutyPersonName = res.machineDevice.dutyPersonName
            this.form.dutyPersonPhone = res.machineDevice.dutyPersonPhone
          }
          this.changeTitle = this.$i18n.t('lang.lab_editMachineRoom')
          this.show = true
          this.saveData = JSON.stringify(this.form)
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    search() {
      // 机房设备选择小区
      this.pageNum = 1
      this.list()
    },
    deleteList(id) {
      let loading = this.$loading()
      this.$confirm(
        this.$i18n.t('lang.lab_isdelete'),
        this.$i18n.t('lang.lab_prompt'),
        {
          confirmButtonText: this.$i18n.t('lang.btn_confirm'),
          cancelButtonText: this.$i18n.t('lang.btn_cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.$delete(`/machineDevice/` + id).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message({
                type: 'success',
                message: this.$i18n.t('lang.lab_del_success')
              })
              this.commit()
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
      .catch(() => {
        loading.close()
        this.$message({
          type: 'info',
          message: this.$i18n.t('lang.lab_del_can')
        })
      })
    }
  }
}
</script>

<style scoped>

</style>